import { Link } from "react-router-dom";
import * as paths from "../../../constants/paths";

export default function JobAlert() {
  return (
    <>
      <div className="job_alert text-center">
        <div className="icon">
          <img src={paths.SITE_BASE_URL + "/images/icon_bell.png"} alt="" />
        </div>
        <div className="h4">Get Job Alerts</div>
        <p>Be the first to know when TechCorp posts new jobs</p>
        <div className="btn_blk">
          <Link to='/job-alerts' className="site_btn simple w-100">
            Create Alert
          </Link>
        </div>
      </div>
    </>
  );
}
